export default __webpack_public_path__ + "static/media/2504082.7c4cc461.png";